var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-layout"},[_c('headerCustom',{attrs:{"layout":"login"}}),_c('main',{staticClass:"login"},[_c('router-view')],1),_c('footerMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }